'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _executivesummaryPoc = require('./executivesummary.poc.component');

var _executivesummaryPoc2 = _interopRequireDefault(_executivesummaryPoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var executivesummaryPOCModule = _angular2.default.module('executivesummaryPOC', [_angularUiRouter2.default]).component('executivesummarypoc', _executivesummaryPoc2.default);

exports.default = executivesummaryPOCModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/executivesummary_poc/executivesummary.poc.js